import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  display: flex;
  padding: 0px 0px 24px;
  gap: 16px;
`;
